import { NotifyHelper } from "../../../helpers/toast";
import { eMonTuongDuongActionsObj } from "../../action-types/category/IMonTuongDuongActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const monTuongDuongActions = {
  ...generateActions(eMonTuongDuongActionsObj, "MON_TUONG_DUONG"),
  ...generateActionForKey(eMonTuongDuongActionsObj, "MON_TUONG_DUONG", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eMonTuongDuongActionsObj, "MON_TUONG_DUONG", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eMonTuongDuongActionsObj, "MON_TUONG_DUONG", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(eMonTuongDuongActionsObj, "MON_TUONG_DUONG", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
